import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  TextField,
  Box,
  Typography,
  Button,
} from '@mui/material';
import { updateIUIPregnancyDetails } from '../../../../api/andrologyApi';
import { setAndrologyData } from '../../../../actions/andrologyAction';
import { useDispatch } from 'react-redux';

export default function PregnancyDetails({
  setIsPregnancyDetails,
  selectedPatientData,
  selectedIuiIdForPregnancyDetails,
  dataAnalyticsData,
  setIuiDetails,
}) {
  const [pregnancyOutcome, setPregnancyOutcome] = useState('');
  const [bHcgReport, setBHcgReport] = useState('');
  const [clinicalPregnancy, setClinicalPregnancy] = useState('');
  const [onGoingPregnancy, setOnGoingPregnancy] = useState('');
  const [deliveryDetails, setDeliveryDetails] = useState('');
  const [comments, setComments] = useState('');
  const [isCompleted, setIsCompleted] = useState(false);

  useEffect(() => {
    let iui;

    if (dataAnalyticsData) {
      iui = dataAnalyticsData;
    } else {
      iui = selectedPatientData.patient.iui.find(
        (item) => item.id === selectedIuiIdForPregnancyDetails,
      );
    }
    if (iui && iui.pregnancyDetails) {
      if (iui.pregnancyDetails.pregnancyOutcome)
        setPregnancyOutcome(iui.pregnancyDetails.pregnancyOutcome);
      if (iui.pregnancyDetails.bHcgReport)
        setBHcgReport(iui.pregnancyDetails.bHcgReport);
      if (iui.pregnancyDetails.clinicalPregnancy)
        setClinicalPregnancy(iui.pregnancyDetails.clinicalPregnancy);
      if (iui.pregnancyDetails.onGoingPregnancy)
        setOnGoingPregnancy(iui.pregnancyDetails.onGoingPregnancy);
      if (iui.pregnancyDetails.deliveryDetails)
        setDeliveryDetails(iui.pregnancyDetails.deliveryDetails);
      if (iui.pregnancyDetails.comments)
        setComments(iui.pregnancyDetails.comments);
      if (iui.pregnancyDetails.isCompleted)
        setIsCompleted(iui.pregnancyDetails.isCompleted);
    }
  }, [
    selectedPatientData,
    selectedIuiIdForPregnancyDetails,
    dataAnalyticsData,
  ]);

  const dispatch = useDispatch();

  const savePregnancyDetails = async ({ isCompleted = false }) => {
    try {
      const data = {
        id: selectedIuiIdForPregnancyDetails,
        pregnancyDetails: {
          pregnancyOutcome,
          bHcgReport,
          clinicalPregnancy,
          onGoingPregnancy,
          deliveryDetails,
          comments,
          isCompleted,
        },
      };
      const response = await updateIUIPregnancyDetails(
        dataAnalyticsData
          ? dataAnalyticsData.patientId
          : selectedPatientData.patient.id,
        data,
      );
      dispatch(setAndrologyData('refresh', true));
      setIsPregnancyDetails(false);
      if (response.status === 200) {
        setIsPregnancyDetails(false);
      }
    } catch (e) {
      console.log('error', e);
    }
  };

  return (
    <Box flex={1} p={3}>
      <Typography variant="h6" gutterBottom>
        Pregnancy Details
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell style={{ fontWeight: 'bold', padding: '6px' }}>
                Pregnancy Outcome
              </TableCell>
              <TableCell style={{ padding: '6px' }}>
                <TextField
                  fullWidth
                  disabled={isCompleted}
                  value={pregnancyOutcome}
                  onChange={(e) => setPregnancyOutcome(e.target.value)}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ fontWeight: 'bold', padding: '6px' }}>
                bHcg Report
              </TableCell>
              <TableCell style={{ padding: '6px' }}>
                <TextField
                  fullWidth
                  disabled={isCompleted}
                  value={bHcgReport}
                  onChange={(e) => setBHcgReport(e.target.value)}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ fontWeight: 'bold', padding: '6px' }}>
                Clinical Pregnancy
              </TableCell>
              <TableCell style={{ padding: '6px' }}>
                <TextField
                  fullWidth
                  disabled={isCompleted}
                  value={clinicalPregnancy}
                  onChange={(e) => setClinicalPregnancy(e.target.value)}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ fontWeight: 'bold', padding: '6px' }}>
                On going Pregnancy
              </TableCell>
              <TableCell style={{ padding: '6px' }}>
                <TextField
                  fullWidth
                  disabled={isCompleted}
                  value={onGoingPregnancy}
                  onChange={(e) => setOnGoingPregnancy(e.target.value)}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ fontWeight: 'bold', padding: '6px' }}>
                Delivery details
              </TableCell>
              <TableCell style={{ padding: '6px' }}>
                <TextField
                  fullWidth
                  disabled={isCompleted}
                  value={deliveryDetails}
                  onChange={(e) => setDeliveryDetails(e.target.value)}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Box mt={3}>
        <Typography variant="h6" gutterBottom>
          Comments
        </Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell style={{ padding: '6px' }}>
                  <TextField
                    fullWidth
                    disabled={isCompleted}
                    // multiline
                    // rows={4}
                    value={comments}
                    onChange={(e) => setComments(e.target.value)}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <div
        style={{
          display: 'flex',
          gap: '10px',
          paddingTop: '4px',
          paddingBottom: '4px',
        }}
      >
        {!dataAnalyticsData && (
          <Button
            variant="contained"
            color="primary"
            className="mt-3"
            disabled={isCompleted}
            onClick={() => {
              if (!isCompleted) {
                savePregnancyDetails({ isCompleted: false });
              }
            }}
            style={{ width: '120px' }}
          >
            Save
          </Button>
        )}
        <Button
          variant="contained"
          color="primary"
          className="mt-3"
          onClick={() => savePregnancyDetails({ isCompleted: true })}
          style={{ width: '120px' }}
        >
          Complete
        </Button>
        {dataAnalyticsData && setIuiDetails && (
          <Button
            variant="contained"
            color="primary"
            className="mt-3"
            onClick={() => {
              setIuiDetails({
                data: {},
                open: false,
              });
            }}
            style={{ width: '120px' }}
          >
            Back
          </Button>
        )}
      </div>
    </Box>
  );
}
